import config from "../../../_config/config";
import axiosInstance from "../../../_helpers/axiosInstance";
import { watchersConstants } from "../../_constants";


//get all jobs
export const get_all_watcher_jobs_action = (page) => async (dispatch) => {
  dispatch({
    type: watchersConstants.GET_JOB_WATCHER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      `${config.watcher.getAllWatcherJobs}?page=${page ? page : 1}`
    );
    if (response.status) {
      dispatch({
        type: watchersConstants.GET_JOB_WATCHER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: watchersConstants.GET_JOB_WATCHER_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//invite watcher action
export const invite_watcher_data_action =
  (data) => async (dispatch) => {
    dispatch({
      type: watchersConstants.GET_JOB_WATCHER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.watcher.inviteUser,
        data
      );
      if (response.status) {
        dispatch({
          type: watchersConstants.GET_JOB_WATCHER_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: watchersConstants.GET_JOB_WATCHER_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };
